import { adminFeedbackReasonLabel } from './feedbackReasons'
import { htmlVisibleText, resolutionStatusLabel } from './feedbackResolution'
import { IChatFeedbackRow, IChatQuestionRow, IChatResolutionRow } from './models'
import { formatLocalDateTime, isButtonQuestion, questionSourceLabel, voteIcon } from './viewModel'

const DASH = '—'
const DELETED_LABEL = 'Sohbet silinmiş'
/** Faz-45: Index çalışanının remote sorusu; ekrandaki "Remote" rozetinin Excel karşılığı. */
const remoteCell = (isRemote?: boolean): string => (isRemote ? 'Evet' : 'Hayır')

/** Buton sorusunun etiketi tur metriğinden gelir; sohbet silinmiş olsa bile korunur. */
const feedbackQuestionCell = (row: IChatFeedbackRow): string => {
  if (isButtonQuestion(row) && row.Question) return `Buton · ${row.Question}`
  if (row.ConversationDeleted) return DELETED_LABEL
  return row.Question ?? DASH
}

/**
 * Excel'de metin KESİLMEZ (sunucu cevabı zaten 2000 karakterde keser). Kullanıcı / e-posta sütunları yalnız
 * sonuçta deneme bayisi satırı varsa eklenir (sunucu kimliği yalnız orada gönderir, ADR-021 eki).
 */
export const buildFeedbackSheetRows = (rows: IChatFeedbackRow[]): Record<string, string | number>[] => {
  const hasIdentity = rows.some(row => row.UserName || row.UserEmail)
  return rows.map(row => ({
    Tarih: formatLocalDateTime(row.VotedAtUtc),
    'SAP Kodu': row.DealerSapCode,
    Bayi: row.DealerName ?? DASH,
    ...(hasIdentity ? { Kullanıcı: row.UserName ?? DASH, 'E-posta': row.UserEmail ?? DASH } : {}),
    Oy: voteIcon(row.Vote),
    // Olumlu oyda neden yoktur.
    Neden: row.Vote === 'up' ? DASH : adminFeedbackReasonLabel(row.ReasonCode),
    Yorum: row.Comment ?? DASH,
    Soru: feedbackQuestionCell(row),
    Cevap: row.ConversationDeleted ? DELETED_LABEL : row.Answer ?? DASH,
    Intent: row.Intent ?? DASH,
    Sonuç: row.Outcome ?? DASH,
    Remote: remoteCell(row.IsRemote),
  }))
}

export const buildQuestionSheetRows = (rows: IChatQuestionRow[]): Record<string, string | number>[] =>
  rows.map(row => ({
    Tarih: formatLocalDateTime(row.AskedAtUtc),
    'SAP Kodu': row.DealerSapCode,
    Bayi: row.DealerName ?? DASH,
    Soru: row.Question ?? DASH,
    // Sunucu cevabı 2000 karakterde keser; Excel'de ayrıca KESİLMEZ.
    Cevap: row.Answer ?? DASH,
    'Nasıl soruldu': questionSourceLabel(row),
    Giriş: row.InputMode ?? DASH,
    Intent: row.Intent ?? DASH,
    Sonuç: row.Outcome ?? DASH,
    Oy: voteIcon(row.Vote),
    Remote: remoteCell(row.IsRemote),
  }))

/**
 * Tamamlananlar Excel'i (Faz-37): kullanıcı kimliği/adı YOKTUR; görüntüleme yalnız sayı + ilk görülme.
 * Popup içeriği HTML yerine görünür metin olarak yazılır.
 */
export const buildResolutionSheetRows = (rows: IChatResolutionRow[]): Record<string, string | number>[] =>
  rows.map(row => ({
    'Kapatma Tarihi': formatLocalDateTime(row.ClosedAtUtc),
    'SAP Kodu': row.DealerSapCode,
    Bayi: row.DealerName ?? DASH,
    Neden: adminFeedbackReasonLabel(row.ReasonCode),
    Yorum: row.Comment ?? DASH,
    Soru: row.QuestionSource === 'button' && row.Question ? `Buton · ${row.Question}` : row.Question ?? DASH,
    Cevap: row.Answer ?? DASH,
    'Oy Tarihi': formatLocalDateTime(row.VotedAtUtc),
    Statü: resolutionStatusLabel(row.Status),
    'İç Not': row.InternalNote ?? DASH,
    Duyuruldu: row.Announced ? 'Evet' : 'Hayır',
    'Popup Başlığı': row.PopupTitle ?? DASH,
    'Popup İçeriği': row.PopupHtml ? htmlVisibleText(row.PopupHtml) : DASH,
    Kapatan: row.ClosedBy ?? DASH,
    'Görüntüleyen Kullanıcı': row.ViewCount,
    'İlk Görülme': row.FirstSeenAtUtc ? formatLocalDateTime(row.FirstSeenAtUtc) : DASH,
    'Kapatma Sayısı': row.ResolutionCount,
    Remote: remoteCell(row.IsRemote),
  }))
